import { useContext } from 'react'
import { i18n } from './index'
import { LanguageContext, type LanguageContextType } from './languageContext.js'

export const useLanguage = (): LanguageContextType => {
  return useContext(LanguageContext)
}

export const useTranslations = () => {
  const [language, _] = useLanguage()
  return i18n.languages[language]
}
